<template>
  <section class="section section__content --text-image">
    <Image
      v-if="content.image"
      :source="content.image"
      class="--round-borders --text-image --shadow"
      v-reveal
    />
    <div>
      <SectionHeader v-if="content.header" :text="content.header" v-reveal="{ delay: 200 }" />
      <h2 class="title" v-reveal="{ delay: 250 }">{{ content.title }}</h2>
      <RawHtml v-if="content.description" :html="content.description" v-reveal="{ delay: 300 }" />
      <ExternalLink
        v-if="content.link && content.label"
        :link="content.link"
        :label="content.label"
        class="--top"
        v-reveal="{ delay: 300 }"
      />
    </div>
  </section>
</template>

<script>
import { Image, RawHtml } from '@/components/global'
import { ExternalLink, SectionHeader } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'ImageTextSection',
  mixins: [DefaultSectionProps],
  components: { ExternalLink, Image, RawHtml, SectionHeader },
}
</script>
